<template>
  <div class="chat-page">
  <div class="chat-detail overflow-hidden">
    <div class="w-full">
      <div class="chat-header" style="background:#ffffff;background-color:#ffffff;">
        <div class="chat-header-bar">
          <div class="chat-header-user" v-if="appear_name" @click="goToInfo(user_info)">
            <div class="chat-header-avatar-wrap">
              <img class="chat-header-avatar" :src="user_info.ThumbPath" alt="" />
              <span v-if="peerOnline && !group_flag" class="chat-online-dot online-pulse-dot" aria-hidden="true"></span>
            </div>
            <div class="chat-header-user-text">
              <span class="chat-header-name" v-if="group_flag == false">{{ user_info.Name }}</span>
              <span class="chat-header-name" v-else>{{ user_info.GroupName }}</span>
              <span class="chat-header-status" :class="{ 'is-typing': !!typing_text, 'is-online': !typing_text && peerOnline }">
                {{ headerStatusText }}
              </span>
            </div>
          </div>
          <div class="chat-header-actions" v-else>
            <button type="button" class="chat-header-action" @click="reply()" v-if="header_reply" aria-label="پاسخ">
              <chat-icon name="reply" color="#000" />
            </button>
            <button type="button" class="chat-header-action" @click="deleteSelected()" aria-label="حذف">
              <chat-icon name="delete" color="#000" />
            </button>
            <button type="button" class="chat-header-action" @click="forwardSelected()" aria-label="ارسال">
              <chat-icon name="share" color="#000" />
            </button>
          </div>

          <button type="button" class="chat-back-btn" @click="backToChats()" aria-label="بازگشت">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
              <path d="M15 18l-6-6 6-6" stroke="#111" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
        </div>
      </div>

    <!-- camera -->
    <div v-if="dialog_camera" class="chat-modal-overlay">
      <div class="chat-modal-panel">
        <div class="chat-modal-toolbar">
          <button type="button" class="chat-modal-icon-btn" @click="dialog_camera = false">
            <chat-icon name="close" color="#fff" />
          </button>
          <span class="chat-modal-title">دوربین</span>
          <button type="button" class="chat-modal-text-btn" @click="downloadImage()">ذخیره</button>
        </div>
        <div v-if="isCameraOpen" class="camera-box">
          <video v-show="!isPhotoTaken" ref="camera" :width="450" :height="337.5" autoplay></video>
          <canvas v-show="isPhotoTaken" id="photoTaken" ref="canvas" :width="450" :height="337.5"></canvas>
        </div>
        <div v-if="isCameraOpen" class="camera-shoot">
          <button type="button" class="button" @click="takePhoto">
            <img src="/img/svg/camera.svg" alt="" />
          </button>
        </div>
        <div v-if="isPhotoTaken && isCameraOpen" class="camera-download"></div>
      </div>
    </div>

    <!-- map -->
    <div v-if="dialog_location" class="chat-modal-overlay" style="overflow:auto;">
      <div class="chat-modal-panel edit-picture blue-border">
        <div class="chat-modal-toolbar">
          <button type="button" class="chat-modal-icon-btn" @click="dialog_location = false">
            <chat-icon name="close" color="#fff" />
          </button>
          <span class="flex-1"></span>
          <button type="button" class="chat-modal-text-btn" @click="save_location()">ارسال</button>
        </div>
        <div ref="map" id="map2" class="basemap"></div>
      </div>
    </div>

    <!-- record (legacy dialog) -->
    <div v-if="dialog_record" class="chat-modal-overlay">
      <div class="chat-modal-panel edit-picture blue-border">
        <div class="chat-modal-toolbar">
          <button type="button" class="chat-modal-icon-btn" @click="dialog_record = false">
            <chat-icon name="close" color="#fff" />
          </button>
          <span class="flex-1"></span>
          <button type="button" class="chat-modal-text-btn" @click="save_location()">ذخیره</button>
        </div>
        <div class="chat-modal-body">
          <div id="controls">
            <button id="recordButton" type="button" v-on:click="startRecording()">Record</button>
            <button id="pauseButton" type="button" disabled>Pause</button>
            <button id="stopButton" type="button" disabled>Stop</button>
          </div>
          <h3>Recordings</h3>
          <ol id="recordingsList"></ol>
        </div>
      </div>
    </div>

    <div class="w-full chat-body">
      <div class="custom_scroll_bar chat-text"  id="chat_detail" v-chat-scroll="{always: false}"
           style="background-image: url('/img/chat_back.svg');">
        <infinite-loading v-if="!messagesLoaded || chatLoad.length > 0" @infinite="infiniteHandler" direction="top">
          <div slot="no-more"></div>
          <div slot="no-results"></div>
        </infinite-loading>
        <div v-if="messagesLoaded && chatLoad.length === 0" class="chat-empty-state">
          پیامی وجود ندارد
        </div>
        <div class="chat-contents">
          <!--         <div v-for="(chat , i) in chatLoad" v-on:click="selectChat(chat , i)" @contextmenu="openMenu($event, chat , i)">-->
          <div v-for="(chat , i) in chatLoad" v-on:click="checkOneClick($event, chat , i)"
               @contextmenu="longClick($event,chat, i)">
            <div class="your-message" v-if="chat.UserSenderId != UserId"
                 v-bind:class="{'is-select': chat.IsSelected ,'fully': chat.Attachments.length > 0 }">
              <div v-if="RecTypeId==1" ><img  style="width: 40px;
    border-radius: 45px;" :src="chat.UserSenderThumbnail"></div>
              <div class="inner">

                <div v-if="chat.Attachments.length > 0">
                  <div v-for="att in chat.Attachments" v-if="chat.Attachments.length == 1 && att.DocType == 3">
                    <img :src="att.DocUrl" class="attachment-img" v-on:click.stop="openImg(att.DocUrl, $event)"/>
                  </div>

                  <!----------------for imaged-------------->

                  <div v-if="chat.Attachments.length > 1 && att.DocType == 3" class="multi-attach"
                       v-for="att in chat.Attachments" @click.stop="openImg(att.DocUrl, $event)">
                    <img :src="att.DocUrl" class="attachment-img"
                         v-if="att.DocType == 3"/>
                    <span v-if="att.DocType == 1" class="attach-icon" @click="openLink(att.DocUrl)">
                     <chat-icon name="link" />
                   </span>
                    <span v-if="att.DocType == 5" class="attach-icon">
                     <chat-icon name="music-note" />
                   </span>

                    <div class="text-center attach-name"
                         v-if="att.Caption != ' ' && att.Caption != '' && att.Caption != null ">
                      {{ att.Caption }}
                    </div>
                    <div class="text-center attach-name" dir="ltr" v-if="att.Caption == ' ' && att.DocType == 3">
                      {{ att.Image_Name }}
                    </div>

                  </div>

                  <!-----------------for other type--------->

                  <div v-if=" att.DocType != 3" class="multi-attach" v-for="att in chat.Attachments"
                       @click="openLink(att.DocType ,att.DocUrl)">
                   <span v-if="att.DocType == 1" class="attach-icon" @click="openLink(att.DocUrl)">
                     <chat-icon name="link" />
                   </span>
                    <span v-if="att.DocType == 5" class="attach-icon">
                     <chat-icon name="music-note" />
                   </span>
                    <span v-if="att.DocType == 2" class="attach-icon">
                     <chat-icon name="file" />
                   </span>
                    <span v-if="att.DocType == 4" class="attach-icon">
                     <chat-icon name="map-marker" />
                   </span>
                    <span v-if="att.DocType == 6" class="attach-icon">
                     <chat-icon name="video-outline" />
                   </span>
                    <div>
                      <!--                    <div class="text-center attach-name" v-if="att.Caption != ' ' && att.Caption != '' && att.Caption != null ">-->
                      <!--                    <div class="text-center attach-name" v-if="att.Caption != ' ' && att.DocType == 7">-->
                      <!--                      <a :href="`tel:+${ att.DocUrl.split('*')[0] }`">-->
                      <!--                        {{ att.Caption }}-->
                      <!--                      </a>-->
                      <!--                    </div>-->
                      <div class="text-center attach-name" v-if="att.Caption != ' ' && att.DocType != 7">
                        {{ att.Caption }}
                      </div>

                      <div class="text-center attach-name" dir="ltr" v-if="att.Caption == ' ' && att.DocType == 1">
                        {{ att.Image_Name }}
                      </div>
                      <div class="audio-msg" v-if="att.DocType == 5">
                        <audio controls class="chat-audio-player">
                          <source :src="att.DocUrl" />
                        </audio>
                      </div>
                    </div>

                  </div>

                </div>
                <p v-if="RecTypeId==1" class="text" style="margin-bottom: 0px;
    font-size: 12px;
    color: #0568bd;" :id="'chat_text_name'+ i">
                  {{ chat.UserSenderName }}
                </p>
                <span class="text" :id="'chat_text_'+ i">
                 {{ chat.MessageText }}
                </span>
                <div class="deliver">
                  {{ get_conversation_date(chat) }}
                </div>
              </div>

            </div>
            <div class="my-message"   v-if="chat.UserSenderId == UserId"
                 v-bind:class="{'is-select': chat.IsSelected ,'fully': chat.Attachments.length > 0 }">
              <div class="inner">
                <!--{{chat.UserSenderId }} {{UserId}} {{GetSender}}-->
                <div v-if="chat.Attachments.length > 0">
                  <div v-for="att in chat.Attachments">
                    <div v-if='chat.Attachments.length == 1 && att.DocType==3'>
                      <img :src="att.DocUrl" class="attachment-img" v-on:click.stop="openImg(att.DocUrl, $event)"/>
                      <div class="text-center attach-name"
                           v-if="att.Caption != ' ' && att.Caption != '' && att.Caption != null">
                        {{ att.Caption }}
                      </div>
                      <div class="text-center attach-name"
                           v-if="att.Caption == ' ' || att.Caption == '' || att.Caption == null">
                        {{ att.Image_Name }}
                      </div>
                    </div>
                    <span class="multi-attach" v-else>
                  <a  @click="openLink(att.DocType ,att.DocUrl)" class="attachment-img" v-if="att.DocType==2" download>
                      <chat-icon name="file" />
                    </a>
                    <img :src="att.DocUrl" class="attachment-img" v-if="att.DocType==3"
                         v-on:click.stop="openImg(att.DocUrl, $event)"/>
                    <span :src="att.DocUrl" class="attachment-img" v-if="att.DocType==5">
                      <audio controls class="chat-audio-player" @click.stop>
                        <source :src="att.DocUrl" type="audio/ogg" />
                      </audio>
                    </span>
                     <span :src="att.DocUrl" class="attachment-img" v-if="att.DocType==6"
                           v-on:click.stop="openLink(att.DocType, att.DocUrl)">
                      <chat-icon name="video-outline" />
                    </span>
                     <div  class="attachment-img" v-if="att.DocType==4"
                           v-on:click="openMap(att.DocUrl)">
                      <img src="/img/location_icon.svg"/>
                    </div>

                    <div class="text-center attach-name"
                         v-if="att.Caption != ' ' && att.Caption != '' && att.Caption != null">
                      {{ att.Caption }}
                    </div>
                    <div class="text-center attach-name"
                         v-if="att.Caption == ' ' || att.Caption == '' || att.Caption == null">
                      {{ att.Image_Name }}
                    </div>
                  </span>
                  </div>
                  <!--                <div v-if="chat.Attachments.length > 1 && chat.Attachments.DocType==3" class="multi-attach" v-for="att in chat.Attachments">-->
                  <!--                  <img :src="att.DocUrl" class="attachment-img" v-if="att.DocType==3" v-on:click="openImg(att.DocUrl)"/>-->
                  <!--                  <div class="text-center attach-name" v-if="att.Caption != ' ' && att.Caption != '' && att.Caption != null">-->
                  <!--                    {{ att.Caption }}-->
                  <!--                  </div>-->
                  <!--                  <div class="text-center attach-name" v-if="att.Caption == ' ' || att.Caption == '' || att.Caption == null">-->
                  <!--                    {{ att.Image_Name }}-->
                  <!--                  </div>-->

                  <!--                </div>-->

                </div>
                <span class="text" :id="'chat_text_'+ i" :value="chat.MessageText">
                {{ chat.MessageText }}
               </span>
                <div class="deliver">
                 <span>
                   <chat-icon v-if="chat.status==10" name="check-all" />
                   <chat-icon v-if="chat.status==5" name="check" />
                   <chat-icon v-if="chat.status==1" name="clock-outline" />
                 </span>
                  {{ get_conversation_date(chat) }}
                </div>
              </div>

            </div>

          </div>
        </div>
      </div>
      <div class="wa-footer">
        <div
          v-show="showEmojiPicker"
          ref="emojiPickerWrap"
          class="wa-emoji-picker-wrap"
        >
          <emoji-picker class="wa-emoji-picker"></emoji-picker>
        </div>

        <div class="attach-tags" v-if="files && files.length">
          <span v-for="item in files" :key="item.name + (item.file || '')" class="tag">
            <img :src="item.file" v-if="ImageOrNot(item.name)"/>
            <span v-else>
              <chat-icon name="file" />
            </span>
            <span class="tag-name">{{ item.name }}</span>
            <span class="tag-close" @click="deleteTag(item)">
              <chat-icon name="close" />
            </span>
          </span>
        </div>

        <div class="wa-recording" v-if="recording_time != 0">
          <span class="wa-recording-dot"></span>
          <span>{{ second_human(recording_time) }}</span>
        </div>

        <div class="wa-attach-sheet" v-if="attach_flag">
          <audio id="audioElement"></audio>
          <div class="wa-attach-grid">
            <button type="button" class="wa-attach-item">
              <span class="wa-attach-icon wa-attach-icon--file">
                <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="#fff" stroke-width="1.8" aria-hidden="true">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/>
                  <path stroke-linecap="round" stroke-linejoin="round" d="M14 2v6h6"/>
                  <path stroke-linecap="round" d="M8 13h8M8 17h5"/>
                </svg>
              </span>
              <span>فایل</span>
              <input type="file" name="file" class="wa-attach-file" id="fileUpload" @change="onFileChange('file')"/>
            </button>
            <button type="button" class="wa-attach-item" @click="open_map">
              <span class="wa-attach-icon wa-attach-icon--map">
                <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="#fff" stroke-width="1.8" aria-hidden="true">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M12 21s7-5.33 7-11a7 7 0 10-14 0c0 5.67 7 11 7 11z"/>
                  <circle cx="12" cy="10" r="2.5" fill="#fff" stroke="none"/>
                </svg>
              </span>
              <span>نقشه</span>
            </button>
          </div>
        </div>

        <div class="wa-reply" v-if="reply_flag">
          <div class="wa-reply-bar"></div>
          <div class="wa-reply-body">
            <span class="wa-reply-label">پاسخ به</span>
            <span class="wa-reply-text">{{ reply_item.MessageText }}</span>
          </div>
          <button type="button" class="wa-reply-close" @click="reply_flag = false" aria-label="بستن">
            <chat-icon name="close" />
          </button>
        </div>

        <div class="wa-row" dir="ltr">
          <div class="wa-bubble" dir="rtl">
            <button type="button" class="wa-icon-btn" @click="toggleEmojiPicker" aria-label="ایموجی">
              <svg viewBox="0 0 24 24" width="24" height="24" fill="#54656f" xmlns="http://www.w3.org/2000/svg">
                <path d="M0 0h24v24H0z" fill="none"/>
                <path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm3.5-9c.83 0 1.5-.67 1.5-1.5S16.33 8 15.5 8 14 8.67 14 9.5s.67 1.5 1.5 1.5zm-7 0c.83 0 1.5-.67 1.5-1.5S9.33 8 8.5 8 7 8.67 7 9.5 7.67 11 8.5 11zm3.5 6.5c2.33 0 4.31-1.46 5.11-3.5H6.89c.8 2.04 2.78 3.5 5.11 3.5z"/>
              </svg>
            </button>

            <input
              ref="chatMessageInput"
              class="wa-text"
              type="text"
              placeholder="پیام خود را بنویسید..."
              v-model="chat_text"
              @keydown.enter="onChatEnter"
              @click="closeClick()"
            />

            <button type="button" class="wa-icon-btn" @click="open_camera_input()" aria-label="دوربین">
              <img src="/img/camera_icon.svg" alt="" />
              <input
                id="fileUploadCamera"
                type="file"
                name="file"
                class="wa-hidden-file"
                accept="image/*"
                capture="camera"
                @change="onFileChangeCamera('file')"
              />
            </button>

            <button type="button" class="wa-icon-btn" @click="openAttach()" aria-label="پیوست">
              <chat-icon name="paperclip" :rotate="45" color="#54656f" />
            </button>
          </div>

          <button
            v-if="chat_text != '' || files.length > 0"
            type="button"
            class="wa-fab"
            @click="send_msg()"
            aria-label="ارسال"
          >
            <chat-icon name="send" color="#fff" />
          </button>
          <button
            v-else
            type="button"
            class="wa-fab"
            id="microphone_record_btn"
            @touchstart.prevent="startRecording"
            @touchend.prevent="stopRecording"
            @mousedown.prevent="startRecording"
            @mouseup.prevent="stopRecording"
            aria-label="ضبط صدا"
          >
            <chat-icon name="microphone" color="#fff" />
          </button>
        </div>
      </div>

    </div>
    </div>
  </div>

    <chat-image-lightbox
      :visible="lightboxOpen"
      :src="lightboxSrc"
      @close="closeLightbox"
    />

    <div v-if="showMenu && hide_menu" class="chat-context-backdrop" @click="showMenu = false"></div>
    <div
      v-if="showMenu && hide_menu"
      class="chat-context-menu"
      :style="{ left: x + 'px', top: y + 'px' }"
      @click.stop
    >
      <button type="button" class="chat-context-item" @click="reply(); showMenu = false">
        <span>{{ $t('reply') }}</span>
      </button>
      <button type="button" class="chat-context-item" @click="copyMsg($event); showMenu = false">
        <span id="mymsg">کپی متن</span>
      </button>
    </div>
  </div>
</template>

<script>
  import InfiniteLoading from 'vue-infinite-loading'
  import VueSlickCarousel from 'vue-slick-carousel'
  import 'vue-slick-carousel/dist/vue-slick-carousel.css'
  import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
  import { bus } from '../../main.js'

  // import VueContext from 'vue-context';
  // import 'vue-context/src/sass/vue-context.scss';
  // import TextareaEmojiPicker from '../../components/TextareaEmojiPicker.vue'
  import 'emoji-picker-element/picker.js'
  import Vue from 'vue'
  import mapboxgl from 'mapbox-gl'
  import ChatIcon from '../../components/chat/ChatIcon.vue'
  import ChatImageLightbox from '../../components/chat/ChatImageLightbox.vue'

  const ignored = Vue.config.ignoredElements
  if (Array.isArray(ignored)) {
    if (ignored.indexOf('emoji-picker') === -1) {
      Vue.config.ignoredElements = ignored.concat('emoji-picker')
    }
  } else {
    Vue.config.ignoredElements = ['emoji-picker']
  }

  export default {
    data () {
      return {
        map: null,
        marker: null,
        dialog_location: false,
        dialog_record: false,
        dialog_camera: false,
        isCameraOpen: false,
        isPhotoTaken: false,
        attach_flag: false,
        showEmojiPicker: false,
        lightboxOpen: false,
        lightboxSrc: '',
        messagesLoaded: false,
        items: '',
        // show_loading: false,
        UserId: '',
        GetSender: '',
        UserGroupId: '',
        RecTypeId: '',
        chat_text: '',
        chat: [],
        password: '',
        up: 0,
        lastMessageId: 0,
        UserName: '',
        chats: [],
        user_info: '',
        first: true,
        chatLoad: [],
        group_flag: false,
        user_flag: false,
        text: '',
        selectedItem: [],
        emojies: '',
        appear_name: true,
        reply_flag: false,
        forward_message: [],
        show_detail: '',
        source_sender_id: 0,
        showMenu: false,
        x: 0,
        y: 0,
        reply_item: '',
        copy_text: '',
        last_select_index: '',
        header_reply: false,
        current_is_typing: 0,
        hide_menu: true,
        mobile: '8001234567',
        // image_name: '',
        split_result: [],
        typing_text: '',
        peerOnline: false,
        typingClearTimer: null,
        tagArray: [],
        tagFlag: false,
        files: [],
        user_location_lat: 0,
        user_location_lng: 0,
        rest: [],
        accessToken: 'pk.eyJ1Ijoiem9vZGtvbWFrIiwiYSI6ImNrOG1vYzVocjAxNm4zbWx2Zmk0bmJ1cHUifQ.rHAeQHubqjcMQTY2eQS1nA',

        user_addresses: [],
        mediaRecorder: null,
        chunks: [],
        audioURL: '',
        recording_time: 0,
        recording_timer: null,
        image_allowd_types:['jpg', 'png', 'PNG', 'jpeg', 'JPEG', 'svg', 'SVG','gif', 'GIF'],
        music_allowd_types:['mp3', 'wav', 'ogg', 'OGG'],
        video_allowd_types:['mp4', 'MP4', 'ogg'],
        file_allowd_types:['pdf', 'docx', 'xlsx', 'txt', 'zip', 'rar', 'pptx', 'doc'],
      }
    },
    beforeDestroy () {
      bus.$off('signalr_methods', this.onSignalrMethods)
      bus.$off('chat_detail_update', this.onChatDetailUpdate)
      this.unbindEmojiPicker()
      this.clearTypingTimer()
      this.sendTypingState(0)
    },
    mounted () {
      // this.configRecording()
      mapboxgl.accessToken = this.accessToken
      try {
        mapboxgl.setRTLTextPlugin(
          'https://api.mapbox.com/mapbox-gl-js/plugins/mapbox-gl-rtl-text/v0.2.3/mapbox-gl-rtl-text.js',
          null,
          true // Lazy load the plugin
        )
      } catch (e) {

      }

      this.bindEmojiPicker()
      this.load_base_data();
      bus.$emit('show_spinner', 'false')
      bus.$emit('signalr_user_ready')
      bus.$on('chat_detail_update', this.onChatDetailUpdate)
      bus.$on('signalr_methods', this.onSignalrMethods)
    },

    watch: {
      chat_text: function () {
        var is_typing = String(this.chat_text || '').trim() !== '' ? 1 : 0
        this.sendTypingState(is_typing)
      }
    },
    computed: {
      headerStatusText () {
        if (this.typing_text) return this.typing_text
        if (!this.group_flag && this.peerOnline) return this.$t('online')
        return (this.user_info && this.user_info.LastSeenDate) || ''
      }
    },
    components: {
      InfiniteLoading,
      VueSlickCarousel,
      ChatIcon,
      ChatImageLightbox,
    },
    methods: {
      onChatDetailUpdate () {
        this.chats = []
        this.user_info = ''
        this.first = true
        this.lastMessageId = 0
        this.chatLoad = []
        this.messagesLoaded = false
        this.load_base_data()
      },
      onSignalrMethods (data) {
        if (!data || !data[0]) return

        if (data[0] == 'is_typing') {
          if (this.isPeerTypingEvent(data[1])) {
            if (data[1].isTyping == 1 || data[1].isTyping === true) {
              this.typing_text = this.$t('isTyping')
              this.resetTypingClearTimer()
            } else {
              this.typing_text = ''
              this.clearTypingTimer()
            }
          }
        }

        if (data[0] == 'user_online') {
          this.applyPeerOnlineStatus(data[1])
        }

        if (data[0] == 'read_message' && data[1] && data[1].receiverId == this.GetReceiver) {
          this.chatLoad.filter(x => x.InboxItemId <= data[1].lastId).forEach(function (val) {
            val.status = 10
          })
        }

        if (data[0] == 'get_message') {
          this.handleIncomingMessage(data[1])
        }
      },
      isMyMessageEcho (incoming) {
        if (!incoming) return false
        var currentUserId = incoming.CurrentUserId
        var myIds = [this.GetSender, this.UserId, localStorage.getItem('userId2')]
        return myIds.some(function (id) { return id != null && id !== '' && id == currentUserId })
      },
      isSelfChat () {
        if (!this.items) return false
        return this.UserId == this.items.UserOrGroupId ||
          this.UserId == this.GetReceiver ||
          this.GetSender == this.GetReceiver ||
          this.GetSender == this.items.UserOrGroupId
      },
      messageAlreadyExists (incoming) {
        if (!incoming) return false
        var inboxId = incoming.InboxItemId
        var dbId = incoming.UserDbId != null ? incoming.UserDbId : incoming.userDbId
        for (var i = this.chatLoad.length - 1; i >= 0; i--) {
          var item = this.chatLoad[i]
          if (!item) continue
          if (inboxId && item.InboxItemId && item.InboxItemId == inboxId) return true
          var localDbId = item.userDbId != null ? item.userDbId : item.UserDbId
          if (dbId != null && localDbId != null && (localDbId == dbId || Number(localDbId) === Number(dbId))) return true
        }
        return false
      },
      applyOwnMessageEcho (incoming) {
        if (!incoming) return false
        var dbId = incoming.UserDbId != null ? incoming.UserDbId : incoming.userDbId
        var start = Math.max(0, this.chatLoad.length - 30)
        for (var i = this.chatLoad.length - 1; i >= start; i--) {
          if (!this.chatLoad[i]) continue
          var localDbId = this.chatLoad[i].userDbId != null ? this.chatLoad[i].userDbId : this.chatLoad[i].UserDbId
          var matchedByDb = dbId != null && localDbId != null && (incoming.UserDbId == localDbId || Number(dbId) === Number(localDbId))
          var matchedByPendingText = !matchedByDb &&
            this.chatLoad[i].status == 1 &&
            this.chatLoad[i].UserSenderId == this.UserId &&
            String(this.chatLoad[i].MessageText || '') === String(incoming.Message || '')
          if (!matchedByDb && !matchedByPendingText) continue

          var message_obj = {
            InboxItemId: incoming.InboxItemId,
            SubmitDateTime: incoming.SubmitDateTime,
            SubmitDateTimeMiladi: incoming.SubmitDateTimeEn,
            UserSenderId: this.UserId,
            UserSenderName: incoming.UserName,
            SourceItem: incoming.SourceItem,
            SendStatus: incoming.SendStatus,
            SourceText: incoming.SourceText,
            SourceSenderName: incoming.SourceSenderName,
            SourceSenderId: incoming.SourceSenderId,
            UserSenderThumbnail: incoming.Thumbnail,
            ReceiverId: this.items.UserOrGroupId,
            status: 5,
            MessageText: incoming.Message,
            Attachments: incoming.Attachments || [],
            userDbId: dbId,
            UserDbId: dbId,
            Robot: incoming.Robot
          }
          this.chatLoad.splice(i, 1, message_obj)
          return true
        }
        return false
      },
      handleIncomingMessage (raw) {
        var incoming = raw
        if (typeof incoming === 'string') {
          try { incoming = JSON.parse(incoming) } catch (e) { return }
        }
        if (!incoming) return

        var currentUserId = incoming.CurrentUserId
        var isMine = this.isMyMessageEcho(incoming)

        // Self-chat / own echo: only update the pending bubble, never append as received
        if (isMine) {
          var matched = this.applyOwnMessageEcho(incoming)
          if (!matched && incoming.InboxItemId && !this.messageAlreadyExists(incoming) && !this.isSelfChat()) {
            // Rare: own message echo without local pending (e.g. another tab) — skip in self chat
          }
          return
        }

        var fromPeer = currentUserId == this.GetReceiver ||
          currentUserId == (this.items && this.items.UserOrGroupId)
        if (!fromPeer) return
        if (this.messageAlreadyExists(incoming)) return

        this.typing_text = ''
        this.clearTypingTimer()
        var recv_obj = {
          InboxItemId: incoming.InboxItemId,
          SubmitDateTime: incoming.SubmitDateTime,
          SubmitDateTimeMiladi: incoming.SubmitDateTimeEn,
          UserSenderId: incoming.CurrentUserId,
          UserSenderName: incoming.UserName,
          SourceItem: incoming.SourceItem,
          SendStatus: incoming.SendStatus,
          SourceText: incoming.SourceText,
          SourceSenderName: incoming.SourceSenderName,
          SourceSenderId: incoming.SourceSenderId,
          UserSenderThumbnail: incoming.Thumbnail,
          ReceiverId: this.UserId,
          MessageText: incoming.Message,
          UserDbId: incoming.UserDbId,
          userDbId: incoming.UserDbId,
          Attachments: incoming.Attachments || [],
          Robot: incoming.Robot,
          status: 5
        }
        this.chatLoad.push(recv_obj)

        var readPayload = {
          ReceiverId: this.UserId,
          SenderId: this.items.UserOrGroupId,
          LastItemId: recv_obj.InboxItemId
        }
        var obj = { method: 'send_read', data: JSON.stringify(readPayload) }
        bus.$emit('signalr_invokes', JSON.stringify(obj))
      },
      isPeerTypingEvent (payload) {
        if (!payload || !this.items) return false
        var sender = payload.sender || payload.Sender || payload.userId || payload.UserId
        return sender == this.GetReceiver || sender == this.items.UserOrGroupId
      },
      parseOnlineFlag (payload) {
        if (payload == null) return null
        if (typeof payload === 'boolean') return payload
        if (typeof payload === 'number') return payload === 1
        var raw = payload.isOnline
        if (raw === undefined) raw = payload.IsOnline
        if (raw === undefined) raw = payload.Online
        if (raw === undefined) raw = payload.online
        if (raw === undefined) raw = payload.Status
        if (raw === undefined) raw = payload.status
        if (raw === undefined) raw = payload.IsOnlineStatus
        if (raw === true || raw === 1 || raw === '1' || raw === 'online' || raw === 'Online') return true
        if (raw === false || raw === 0 || raw === '0' || raw === 'offline' || raw === 'Offline') return false
        return null
      },
      applyPeerOnlineStatus (payload) {
        if (!payload || !this.items || this.group_flag) return
        var userId = payload.userId || payload.UserId || payload.sender || payload.Sender || payload.UserOrGroupId || payload.GetReceiver
        if (userId && userId != this.GetReceiver && userId != this.items.UserOrGroupId) return
        var online = this.parseOnlineFlag(payload)
        if (online === null) return
        this.peerOnline = online
        if (this.user_info && typeof this.user_info === 'object') {
          this.$set(this.user_info, 'IsOnline', online ? 1 : 0)
          if (online) {
            this.$set(this.user_info, 'LastSeenDate', this.$t('online'))
          } else {
            var last = String(this.user_info.LastSeenDate || '')
            if (last === this.$t('online') || last.indexOf('آنلاین') !== -1 || last.toLowerCase().indexOf('online') !== -1) {
              this.$set(this.user_info, 'LastSeenDate', '')
            }
          }
        }
      },
      clearTypingTimer () {
        if (this.typingClearTimer) {
          clearTimeout(this.typingClearTimer)
          this.typingClearTimer = null
        }
      },
      resetTypingClearTimer () {
        var self = this
        this.clearTypingTimer()
        this.typingClearTimer = setTimeout(function () {
          self.typing_text = ''
          self.typingClearTimer = null
        }, 4000)
      },
      sendTypingState (is_typing) {
        if (!this.items || !this.UserId) return
        if (this.current_is_typing == is_typing) return
        var data = {
          sender: this.UserId,
          receiver: this.items.UserOrGroupId,
          recType: this.items.RecType,
          isTyping: is_typing,
          IsWeb: 1
        }
        var obj = { method: 'is_typing', data: JSON.stringify(data) }
        bus.$emit('signalr_invokes', JSON.stringify(obj))
        this.current_is_typing = is_typing
      },
      if_file_allowed(file_name){
        console.log("check file allowed",file_name);
        if(this.image_allowd_types.includes(file_name.split('.')[1])) {
          return true;
        }
        if(this.music_allowd_types.includes(file_name.split('.')[1])) {
          return true;
        }
        if(this.video_allowd_types.includes(file_name.split('.')[1])) {
          return true;
        }
        if(this.file_allowd_types.includes(file_name.split('.')[1])) {
          return true;
        }
        return  false

      },

      load_base_data(){
        var user_data = JSON.parse(localStorage.getItem('profile'))
        console.log('useeeer ' + JSON.stringify(user_data))
        this.password = localStorage.getItem('password')
        this.UserId = user_data.UserId
        this.UserName = user_data.UserName
        this.GetSender = localStorage.getItem('userId2') || String(user_data.UserId)
        if (!localStorage.getItem('userId2') && user_data.UserId) {
          localStorage.setItem('userId2', String(user_data.UserId))
        }
        this.items = JSON.parse(localStorage.getItem('lastChat'))
        // console.log("lastChat " + JSON.stringify(this.items));
        this.UserGroupId = this.items.UserOrGroupId
        this.RecTypeId = this.items.RecType
        this.GetReceiver = this.items.GetReceiver
        console.log('UserOrGroupId', this.items.UserOrGroupId)
        this.forward_message = JSON.parse(localStorage.getItem('lastForward'))
        localStorage.setItem('lastForward', null)

        this.loadChats()

        if (this.items.RecType == 0) {
          this.getUserInfo()
          this.group_flag = false
          this.user_flag = true
        } else {
          this.getGroupInfo()
          this.group_flag = true
          this.user_flag = false
        }
        this.scrollToEnd()
      },
      save_location () {
        this.attach_flag = !this.attach_flag
        var Obj
        this.dialog_location = false
        Obj = { name: 'map', DocUrl: [this.marker._lngLat.lat, this.marker._lngLat.lng], upload: 1 }
        this.files.push(Obj)
      },
      open_map () {
        var self = this
        // init the map
        this.dialog_location = true

        setTimeout(function () {
          self.map_function()

        }, 1000)
      },
      map_function () {
        var self = this
        // self.map.resize()
        if(self.map!=null){
          self.map.remove();
        }
        self.map = new mapboxgl.Map({
          container: 'map2',
          style: 'mapbox://styles/mapbox/streets-v11', // stylesheet location
          center: [51.37734351262877, 35.697451890638886],
          zoom: 14 // starting zoom
        })
        self.map.resize()

        self.map.addControl(
          new mapboxgl.GeolocateControl({
            positionOptions: {
              enableHighAccuracy: true
            },
// When active the map will receive updates to the device's location as it changes.
            trackUserLocation: true,
// Draw an arrow next to the location dot to indicate which direction the device is heading.
            showUserHeading: true
          })
        )
        var centro
        self.marker = new mapboxgl.Marker({})
          .setLngLat([0, 0])
          .addTo(self.map)

        self.map.on('drag', function () {
          centro = self.map.getCenter()
          self.user_location_lat = centro.lat
          self.user_location_lng = centro.lng
          self.marker.setLngLat(centro)
        })
        self.map.on('zoom', function () {
          centro = self.map.getCenter()
          self.user_location_lat = centro.lat
          self.user_location_lng = centro.lng
          self.marker.setLngLat(centro)
        })

        self.map.on('load', function () {
          // self.show_polygon();
          self.map.resize()
          centro = self.map.getCenter()
          self.user_location_lat = centro.lat
          self.user_location_lng = centro.lng
          self.marker.setLngLat(centro)
          console.log('map loaded')
          document.getElementsByClassName("mapboxgl-ctrl-top-right")[0].getElementsByClassName("mapboxgl-ctrl-geolocate")[0].classList.add("mapboxgl-ctrl-icon")
        })
      },
      onDragEnd () {
        // var lngLat = marker.getLngLat();
        self.user_location_lat = this.marker.getLngLat().lat
        self.user_location_lng = this.marker.getLngLat().lng
      },
      onDragStart () {
        // var lngLat = marker.getLngLat();
        console.log('drag started')
        self.user_location_lat = this.marker.getLngLat().lat
        self.user_location_lng = this.marker.getLngLat().lng
      },
      ImageOrNot (item) {
        // if (item.split('.')[1] == 'jpg' || item.split('.')[1] == 'png' || item.split('.')[1] == 'PNG' || item.split('.')[1] == 'jpeg' || item.split('.')[1] == 'JPEG') {
        console.log("image or not ",item)
        if (this.image_allowd_types.includes(item.split('.')[1])) {
          console.log("image or not = is image")

          return true
        }
      },
      second_human (seconds) {
        var numhours = Math.floor(((seconds % 31536000) % 86400) / 3600)
        var numminutes = Math.floor((((seconds % 31536000) % 86400) % 3600) / 60)
        var numseconds = (((seconds % 31536000) % 86400) % 3600) % 60
        if (numhours < 10) {
          numhours = '0' + '' + numhours
        }
        if (numminutes < 10) {
          numminutes = '0' + '' + numminutes
        }
        if (numseconds < 10) {
          numseconds = '0' + '' + numseconds
        }
        return numminutes + ':' + numseconds
      },
      startRecording () {
        var self = this

        if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
          console.log('mediaDevices supported..')

          navigator.mediaDevices.getUserMedia({
            audio: true
          }).then(stream => {
            self.mediaRecorder = new MediaRecorder(stream)

            self.mediaRecorder.ondataavailable = (e) => {
              self.chunks.push(e.data)
            }

            self.mediaRecorder.onstop = () => {
              // const blob = new Blob(self.chunks, {type: 'audio/mp3;codecs=opus'})
              const blob = new Blob(self.chunks, { type: 'audio/ogg' })
              const file = new File([blob], 'recording.ogg')
              self.chunks = []
              self.audioURL = window.URL.createObjectURL(blob)
              // document.querySelector('audio').src = self.audioURL
              // this.attach_flag = !this.attach_flag
              console.log('audio is ', self.audioURL)
              console.log('audio is ', self.recording_time)

              if (self.recording_time > 1) {
                // var blob_file = new File([self.audioURL], "yourfilename.mp3", { type: "audio/mp3"} );
                // const blob_file = new File([self.audioURL], 'audiooo.mp3', {
                //   type: self.audioURL.type,
                // });
                var Obj = { name: 'audio', file: file, DocUrl: self.audioURL, upload: 0, DocType: 5 }
                this.files.push(Obj)
              }
              self.recording_time = 0
              clearTimeout(self.recording_timer)
            }
          }).catch(error => {
            console.log('Following error has occured : ', error)
          })
        } else {
          // stateIndex = ''
          // application(stateIndex)
        }
// mediaRecorder setup for audio
        if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
          console.log('mediaDevices supported..')
          document.getElementById('microphone_record_btn').classList.add('record_button_active')

          navigator.mediaDevices.getUserMedia({
            audio: true
          }).then(stream => {
            self.mediaRecorder.start()
            self.recording_time = 0

            self.run_recording_time()
          }).catch(error => {
            console.log('Following error has occured : ', error)
          })
        } else {
          // application(stateIndex)
        }

        // const addAudio = () => {
        //   const audio = document.createElement('audio')
        //   audio.controls = true
        //   audio.src = audioURL
        //   // display.append(audio)
        // }
      },
      run_recording_time () {
        var self = this
        self.recording_timer = setTimeout(() => {
          self.recording_time += 1
          self.run_recording_time()
        }, 1000)
      },
      stopRecording () {
        var self = this
        document.getElementById('microphone_record_btn').classList.remove('record_button_active')

// mediaRecorder setup for audio
        if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
          console.log('mediaDevices supported..')

          navigator.mediaDevices.getUserMedia({
            audio: true
          }).then(stream => {
            self.mediaRecorder.stop()
          }).catch(error => {
            console.log('Following error has occured : ', error)
          })
        } else {
          // stateIndex = ''
          // application(stateIndex)
        }
      },
      dataURLtoFile (dataurl, filename) {
        var arr = dataurl.split(',')
        var mime = arr[0].match(/:(.*?);/)[1]
        var bstr = atob(arr[1])
        var n = bstr.length
        var u8arr = new Uint8Array(n)

        while (n--) {
          u8arr[n] = bstr.charCodeAt(n)
        }

        return new File([u8arr], filename, { type: mime })
      },
      uploadAttach (index, length, attach) {
        if (attach.upload == 1) {
          console.log('attach[j]', attach)
          attach.upload = 1
          this.rest.push(attach)

          console.log('equal', this.rest)
          this.checkAttachFinish()
        } else {
          var form_data = new FormData()
          var myfile
          console.log('attach aupload', attach)
          if (attach.Caption != 'audio') {
            myfile = this.dataURLtoFile(attach.file, attach.Image_Name)
          } else {
            myfile = attach.file
          }
          // console.log("this.extention(attach[i].Image_Name)",this.extention(attach.Image_Name.split('.')[1]))
          form_data.append('Format', attach.Image_Name.split('.')[1])
          form_data.append('MediaType0', this.extention(attach.Image_Name.split('.')[1]))
          form_data.append('DocType', attach.DocType)
          form_data.append('Upload', myfile)
          console.log('hi')
          var self = this
          this.axios.post('UploadInboxFile', form_data, {})
            .then(response => {
              // console.log("resss", response.data.path)
              // attach[j].DocUrl = response.data.path;
              console.log('attach[j]', attach)
              attach.DocUrl = response.data.path
              attach.upload = 1
              attach.file = null
              self.rest.push(attach)

              // return attach;
              // if(index+1 == length){
              console.log('equal', self.rest)
              self.checkAttachFinish()
              // }
              // self.chat_text = "";
            }).catch(e => {
            // self.errors.push(e);
            console.log('error', e)
          })
        }
      },
      checkAttachFinish () {
        var flag = false
        for (var i = 0; i < this.rest.length; i++) {
          console.log('check', this.rest[i])
          if (this.rest[i].upload == 0) {
            flag = true
          }
        }
        if (flag == false) {
          this.sendSocket(this.rest)
        }
      },
      onChatEnter (e) {
        if (e && (e.isComposing || e.keyCode === 229)) {
          return
        }
        if (e) {
          e.preventDefault()
        }
        this.send_msg()
      },
      send_msg () {
        const inputEl = this.$refs.chatMessageInput
        if (inputEl && typeof inputEl.value === 'string') {
          this.chat_text = inputEl.value
        }
        this.showEmojiPicker = false
        this.attach_flag = false
        console.log('send_message file', this.files.length)
        var attach = []

        if (this.files.length > 0) {
          for (var i = 0; i < this.files.length; i++) {
            var x = this.files[i].name
            console.log('tagg', this.files[i])
            if (this.files[i].name == 'map') {
              console.log('map', this.files[i])
              // attach.push({ Caption: this.files[i].name, DocType:this.files[i].DocUrl, upload:this.files[i].upload })
              attach.push({
                Caption: this.files[i].name,
                DocType: 4,
                upload: 1,
                file: this.files[i].DocUrl[0] + '*' + this.files[i].DocUrl[1],
                DocUrl: this.files[i].DocUrl[0] + '*' + this.files[i].DocUrl[1]
              })
            }
            // || this.tagArray[i].includes(".PNG") || this.tagArray[i].includes(".jpeg") || this.tagArray[i].includes(".JPEG")
            else if (this.image_allowd_types.includes(this.files[i].name.split('.')[1])) {
              console.log('iiiiiiiiiiiimage', this.files[i])
              attach.push({
                Caption: this.files[i].name,
                Image_Name: this.files[i].name,
                DocType: 3,
                upload: 0,
                file: this.files[i].file,
                DocUrl: 'https://zoodbest.com/ZbFiles/UserInboxItems/Images/15122020143730_56893.jpg'
              })
            } else if (this.music_allowd_types.includes(this.files[i].name.split('.')[1])) {
              // this.messages.push('<a href=../assets/image/'+this.tagArray[i]+' download><div class="file-send-format"><span class="file-icon">'+this.tagArray[i]+'</span></div></a>')
              attach.push({
                Caption: this.files[i].name,
                Image_Name: this.files[i].name,
                file: this.files[i].file,
                DocType: 5,
                upload: 0,
                DocUrl: 'http://zoodbest.com/ZbFiles/UserInboxItemsTh45/Images/13032021133805_34656.png'
              })
            } else if (this.files[i].name == 'audio') {
              // this.messages.push('<a href=../assets/image/'+this.tagArray[i]+' download><div class="file-send-format"><span class="file-icon">'+this.tagArray[i]+'</span></div></a>')
              attach.push({
                Caption: this.files[i].name,
                Image_Name: this.files[i].name + '.mp3',
                file: this.files[i].file,
                DocType: 5,
                upload: 0,
                DocUrl: this.files[i].DocUrl
              })
            } else if (this.video_allowd_types.includes(this.files[i].name.split('.')[1])) {
              // this.messages.push('<a href=../assets/image/'+this.tagArray[i]+' download><div class="file-send-format"><span class="file-icon">'+this.tagArray[i]+'</span></div></a>')
              attach.push({
                Caption: this.files[i].name,
                Image_Name: this.files[i].name,
                DocType: 6,
                upload: 0,
                file: this.files[i].file,
                DocUrl: 'http://zoodbest.com/ZbFiles/UserInboxItemsTh45/Images/13032021133805_34656.png'
              })
            } else if (this.file_allowd_types.includes(this.files[i].name.split('.')[1])) {
              // this.messages.push('<a href=../assets/image/'+this.tagArray[i]+' download><div class="file-send-format"><span class="file-icon">'+this.tagArray[i]+'</span></div></a>')
              attach.push({
                Caption: this.files[i].name,
                Image_Name: this.files[i].name,
                upload: 0,
                file: this.files[i].file,
                DocType: 2,
                DocUrl: 'http://zoodbest.com/ZbFiles/UserInboxItemsTh45/Images/13032021133805_34656.png'
              })
            }
          }
          console.log('send_message', attach.length)
          var rest = []
          for (var j = 0; j < attach.length; j++) {
            this.uploadAttach(j, attach.length, attach[j])

            console.log('return restttt', this.rest)
          }
        } else {
          if (String(this.chat_text || '').trim() !== '') {
            this.sendSocket(attach)
          }
        }
        console.log('sooon')
      },
      sendSocket (attach) {
        console.log('socket')
        var user_db = Math.floor((Math.random() * 1000) + 1)
        user_db = user_db * -1
        var message_obj = {
          InboxItemId: 0,
          SubmitDateTime: '',
          userDbId: user_db,
          status: 1,
          SubmitDateTimeMiladi: '',
          UserSenderId: this.UserId,
          UserSenderName: '',
          SourceItem: this.source_sender_id,
          SendStatus: 1,
          SourceText: '',
          SourceSenderName: '',
          SourceSenderId: '',
          UserSenderThumbnail: '',
          ReceiverId: this.items.UserOrGroupId,
          MessageText: this.chat_text,
          Attachments: this.rest,
          Robot: []
        }
        var send_message_obj = {
          userDbId: user_db,
          sender: this.UserId,
          SourceItem: this.source_sender_id,
          sendStatus: 1,
          recType: this.items.RecType,
          SourceText: '',
          SourceSenderName: '',
          SourceSenderId: '',
          receiverId: this.items.UserOrGroupId,
          message: this.chat_text,
          Attachments: Array.isArray(this.rest) ? this.rest : [],
        }
        console.log('send_message payload', send_message_obj)
        this.files = []
        this.chatLoad.push(message_obj)
        var obj = { method: 'send_message', data: JSON.stringify(send_message_obj) }
        bus.$emit('signalr_invokes', JSON.stringify(obj))
        this.reply_flag = false
        this.source_sender_id = 0
        // }
        this.chat_text = ''
        this.rest = []
        this.files = []
      },
      downloadImage () {
        if (this.isPhotoTaken == true) {
          this.isCameraOpen = false
          // const download = document.getElementById("downloadPhoto");
          const preview = document.getElementById('photoTaken')
          const canvas = document.getElementById('photoTaken').toDataURL('image/jpeg')
          // .replace("image/jpeg", "image/octet-stream");
          console.log('canvas:', canvas)
          var obj = { file: canvas, preview: preview, upload: 0, name: 'myphoto.jpg' }
          this.files.push(obj)
          this.dialog_camera = false
          this.isPhotoTaken = false
          console.log('dwn', obj)
          // this.tagArray.push(obj)
        }
        // download.setAttribute("href", canvas);
      },
      openCamera () {
        this.isCameraOpen = true
        this.createCameraElement()
        this.dialog_camera = true
      },
      takePhoto () {
        this.isPhotoTaken = true
        const context = this.$refs.canvas.getContext('2d')
        context.drawImage(this.$refs.camera, 0, 0, 450, 337.5)
      },
      createAudioElement () {
        try {
          const constraints = (window.constraints = {
            audio: true,
            video: false
          })
          return navigator.mediaDevices.getUserMedia(constraints)
        } catch (err) {
          alert(err)
        }
      },
      createCameraElement () {
        try {
          const constraints = (window.constraints = {
            audio: false,
            video: true
          })

          navigator.mediaDevices
            .getUserMedia(constraints)
            .then(stream => {
              this.$refs.camera.srcObject = stream
            })
            .catch(error => {
              alert('دستگاه شما دوربین را پشتیبانی نمیکند')
            })
        } catch (err) {
          alert(err)
        }
      },
      deleteTag (item) {
        console.log('delete')
        this.files.splice(this.files.indexOf(item), 1)
        if (this.files.length == 0) {
          this.tagFlag = false
        }
      },
      onFileChange (name) {
        this.attach_flag = !this.attach_flag
        // var files = e.target.files || e.dataTransfer.files;
        var self = this

        if (name == 'file') {
          var reader = new FileReader()
          var f = document.getElementById('fileUpload').files

          if (this.if_file_allowed(f[0].name)) {
            console.log('file')
            reader.onloadend = function () {
              var obj = { file: reader.result, preview: reader.result, upload: 0, name: f[0].name }
              self.files.push(obj)
            }
            reader.readAsDataURL(f[0])
            console.log('111', self.files)
            // this.tagArray.push(f[0].name)
            // console.log("files", this.tagArray);
            this.tagFlag = true
            if (!self.files.length) {
            }
          }
        }
      },
      open_camera_input () {
        document.getElementById('fileUploadCamera').click()
      },
      onFileChangeCamera (name) {
        this.attach_flag = !this.attach_flag
        // var files = e.target.files || e.dataTransfer.files;
        var self = this

        if (name == 'file') {
          var reader = new FileReader()
          var f = document.getElementById('fileUploadCamera').files

          if (f[0].name.toLowerCase().includes('.pdf') || f[0].name.toLowerCase().includes('.docx') || f[0].name.toLowerCase().includes('.xlsx') || f[0].name.toLowerCase().includes('.txt') || f[0].name.toLowerCase().includes('.wav') || f[0].name.toLowerCase().includes('.mp3') || f[0].name.toLowerCase().includes('.mp4') || f[0].name.toLowerCase().includes('.MP4') || f[0].name.toLowerCase().includes('.ogg') || f[0].name.toLowerCase().includes('.jpg') || f[0].name.toLowerCase().includes('.png') || f[0].name.toLowerCase().includes('.PNG') || f[0].name.toLowerCase().includes('.jpeg') || f[0].name.toLowerCase().includes('.JPEG')) {
            console.log('file')
            reader.onloadend = function () {
              var obj = { file: reader.result, preview: reader.result, upload: 0, name: f[0].name }
              self.files.push(obj)
            }
            reader.readAsDataURL(f[0])
            console.log('111', self.files)
            // this.tagArray.push(f[0].name)
            // console.log("files", this.tagArray);
            this.tagFlag = true
            if (!self.files.length) {
            }
          }
        }
      },
      openAttach () {
        this.attach_flag = !this.attach_flag
      },
      openLink (type, link) {
        link = link.replace('http://zoodbest',"https://zoodbest");
        if (type == 1) {
          console.log('link ', link)
          window.open(link, '_blank')
        }
        if (type == 6) {
          window.open(link, '_blank')
        }
        if (type == 2) {
          window.open(link, '_blank')
        }
        if (type == 4) {
          link = link.split('*')
          link = 'https://www.google.com/maps/search/?api=1&query=' + link
          window.open(link, '_blank')
        }
      },
      openVideo () {

      },
      closeClick () {
        this.showEmojiPicker = false
        this.attach_flag = false
        this.showMenu = false
      },
      openImg (item, e) {
        if (e) {
          e.stopPropagation()
          e.preventDefault()
        }
        const url = (item || '').replace('http://zoodbest', 'https://zoodbest')
        if (!url) return
        this.lightboxSrc = url
        this.lightboxOpen = true
      },
      closeLightbox () {
        this.lightboxOpen = false
        this.lightboxSrc = ''
      },
      openMap (item) {
        window.open("https://www.google.com/maps?q="+item.split("*")[0]+","+item.split("*")[1]+"&z=17&hl=en")
      },
      copyMsg (e) {
        var text_id = 'chat_text_' + this.last_select_index
        console.log('text_id', text_id)
        var copyText = document.getElementById(text_id)
        var input = document.body.appendChild(document.createElement('input'))
        input.value = copyText.textContent
        // input.focus();
        input.select()
        document.execCommand('copy')

        console.log('Copied the text: ' + copyText.textContent)
        input.setAttribute('type', 'hidden')
      },
      reply () {
        console.log('reply chat: ', this.show_detail)
        this.reply_flag = true
        this.source_sender_id = this.show_detail.InboxItemId
        this.reply_item = this.show_detail
      },
      checkOneClick (e, item, i) {
        const target = e.target
        if (target && (target.tagName === 'IMG' || (target.classList && target.classList.contains('attachment-img')))) {
          return
        }
        // this.show_detail = item;
        this.last_select_index = i
        var myNode = e.srcElement.attributes[0].nodeValue
        console.log('eventt:', e.srcElement.attributes[0].nodeValue)
        if (this.selectedItem.length == 0) {
          if (myNode == 'inner' || myNode == 'my-message' || myNode == 'deliver' || myNode == 'my-message fully' || myNode == 'your-message' || myNode == 'your-message fully') {
            e.preventDefault()
            this.showMenu = false
            this.x = e.clientX
            this.y = e.clientY
            this.show_detail = item
            this.$nextTick(() => {
              this.showMenu = true
              this.hide_menu = true
            })
          }
        } else {
          // console.log("before selected");
          this.selectChat(item, i)
        }
      },
      longClick (e, chat, i) {
        this.show_detail = chat
        e.preventDefault()
        // console.log("long");
        this.selectChat(chat, i)
      },
      replySelected () {
        console.log('reply')
      },
      forwardSelected () {
        console.log('forward')
        this.$router.push({ path: '/message-tab', params: {} })
        localStorage.setItem('lastForward', JSON.stringify(this.selectedItem))
      },
      deleteSelected () {

      },
      selectChat (chat, i) {
        this.selectedItem = []
        var cnt = 0
        if (chat.IsSelected == false) {
          chat.IsSelected = true
          this.chatLoad.splice(i, 1, chat) // replace it
        } else {
          chat.IsSelected = false
          this.chatLoad.splice(i, 1, chat)
        }
        for (var j = 0; j < this.chatLoad.length; j++) {
          if (this.chatLoad[j].IsSelected == true) {
            this.selectedItem.push(this.chatLoad[j])
            cnt++
          }
        }
        if (cnt == 1) {
          this.show_detail = this.selectedItem[0]

          this.header_reply = true
        } else {
          this.header_reply = false
          this.show_detail = chat
        }
        if (this.selectedItem.length > 0) {
          this.appear_name = false
        } else {
          this.appear_name = true
        }
        // console.log(cnt)
        //
        console.log('this.selectedItem ', this.selectedItem)
      },
      extention (file_extention) {
        var x = file_extention.toLowerCase()
        if (x == 'aac') return 'audio/aac'
        if (x == 'ogg') return 'audio/aac'
        if (x == 'avi') return 'video/x-msvideo'
        if (x == 'doc') return 'application/msword'
        if (x == 'docx') return 'application/vnd'
        if (x == 'jpg') return 'image/jpeg'
        if (x == 'jpeg') return 'image/jpeg'
        if (x == 'gif') return 'image/gif'
        if (x == 'mpeg') return 'video/mpeg'
        if (x == 'png') return 'image/png'
        if (x == 'pdf') return 'application/pdf'
        return 'nothing'
      },

      onEmojiPickerClick (event) {
        const raw = event && event.detail
        const apply = (detail) => {
          const text = (detail && (detail.unicode || (detail.emoji && detail.emoji.unicode))) || ''
          if (!text) return
          const input = this.$refs.chatMessageInput
          const current = this.chat_text || ''
          if (input && typeof input.selectionStart === 'number') {
            const start = input.selectionStart
            const end = typeof input.selectionEnd === 'number' ? input.selectionEnd : start
            this.chat_text = current.slice(0, start) + text + current.slice(end)
            this.$nextTick(() => {
              input.focus()
              const pos = start + text.length
              if (input.setSelectionRange) {
                input.setSelectionRange(pos, pos)
              }
            })
          } else {
            this.chat_text = current + text
            this.$nextTick(() => {
              if (input) input.focus()
            })
          }
        }
        if (raw && typeof raw.then === 'function') {
          raw.then(apply)
        } else {
          apply(raw)
        }
      },
      bindEmojiPicker () {
        this.$nextTick(() => {
          const wrap = this.$refs.emojiPickerWrap
          if (!wrap) return
          const picker = wrap.querySelector('emoji-picker')
          if (!picker || picker.__emojiBound) return
          picker.addEventListener('emoji-click', this.onEmojiPickerClick)
          picker.__emojiBound = true
        })
      },
      unbindEmojiPicker () {
        const wrap = this.$refs.emojiPickerWrap
        const picker = wrap && wrap.querySelector('emoji-picker')
        if (!picker || !picker.__emojiBound) return
        picker.removeEventListener('emoji-click', this.onEmojiPickerClick)
        picker.__emojiBound = false
      },
      toggleEmojiPicker () {
        this.showEmojiPicker = !this.showEmojiPicker
        this.attach_flag = false
        if (this.showEmojiPicker) {
          this.bindEmojiPicker()
        }
      },
      goToInfo (item) {
        const last_user_info = {
          RecType: item.RecType,
          UserOrGroupId: item.UserOrGroupId
        }
        localStorage.setItem('LastUserInfo', JSON.stringify(last_user_info))
        this.$router.push({ path: 'contact-info', params: {} })
      },
      infiniteHandler ($state) {
        var self = this
        // console.log("first is "+ this.first);
        if (this.first) {
          setTimeout(() => {
            $state.loaded()
          }, 1000)
          return false
        } else {
          console.log('not first')
        }

        // console.log("self.chatLoad[0] ", self.chats.length)

        // console.log("hiii"+ self.chatLoad[0].InboxItemId)
        if (self.chats.length > 0) {
          setTimeout(() => {
            self.lastMessageId = self.chatLoad[0].InboxItemId
            self.loadChats($state)
          }, 1000)
        } else {
          $state.complete()
        }
      },
      backToChats () {
        // this.$router.push({ path: '/dashboard', params: {} })
        this.$router.go(-1)
      },
      loadChats ($state) {
        const send_data = {
          ReceiverId: this.items.UserOrGroupId,
          UserId: this.UserId,
          RecType: this.items.RecType,
          LastMessageId: this.lastMessageId,
          Password: this.password,
        }
        // for(var i=0; i<this.forward_message.length ;i++){
        //   if(this.forward_message[i].IsSelected == true){
        //     this.forward_message[i].IsSelected = false;
        //   }
        // }
        console.log('forward_message', this.forward_message)

        var self = this
        this.axios.post('/LoadContactChats', send_data, {})
          .then(response => {
            if (response.data.error == 0) {
              // console.log("response edit", response.data.messages);
              self.date_now = response.data.dateNow
              self.chats = response.data.messages || []
              for (var i = 0; i < self.chats.length; i++) {
                if (response.data.maxReadId >= self.chats[i].InboxItemId) {
                  self.chats[i].status = 10
                } else {
                  self.chats[i].status = 5
                }

                self.chats[i].IsSelected = false
                if (self.chats[i].Attachments && self.chats[i].Attachments.length != 0) {
                  for (var j = 0; j < self.chats[i].Attachments.length; j++) {
                    var mySplit = (self.chats[i].Attachments[j].DocUrl || '').split('/')
                    this.split_result = mySplit[mySplit.length - 1]
                    self.chats[i].Attachments[j].Image_Name = mySplit[mySplit.length - 1]
                  }
                } else if (!self.chats[i].Attachments) {
                  self.chats[i].Attachments = []
                }
              }
              self.chats.reverse()
              if (self.first) {
                self.first = false
                // self.infiniteHandler()
                self.chatLoad = self.chats
              } else {
                // console.log("self.chatLoad:" + JSON.stringify(self.chatLoad[0]))
                self.chats.reverse()
                for (var i = 0; i < self.chats.length; i++) {
                  self.chatLoad.splice(0, 0, self.chats[i])
                }
              }
              if ($state != null) {
                if (self.chats.length > 0) {
                  $state.loaded()
                } else {
                  $state.complete()
                }
              }
              if (self.chats.length > 0) {
                var data = {
                  ReceiverId: this.UserId,
                  SenderId: this.items.UserOrGroupId,
                  LastItemId: self.chats[self.chats.length - 1].InboxItemId
                }
                var obj = { method: 'send_read', data: JSON.stringify(data) }
                bus.$emit('signalr_invokes', JSON.stringify(obj))
              }
            }
          })
          .catch(e => {
            if ($state != null) {
              $state.complete()
            }
          })
          .finally(() => {
            self.messagesLoaded = true
            if (self.first) {
              self.first = false
            }
          })
        console.log('this.forward_message', this.forward_message)
        if (this.forward_message != null) {
          for (var i = 0; i < this.forward_message.length; i++) {
            if (this.forward_message[i].IsSelected == true) {
              this.forward_message[i].IsSelected = false
            }
            this.chatLoad.push(this.forward_message[i])
          }
        }
        // if(this.forward_message != null){
        //   // this.forward_message = JSON.parse(this.forward_message);
        //   for(var i=0 ;i< this.forward_message.length;i++) {
        //     this.chatLoad.push(this.forward_message[i])
        //   }
        // }
      },
      getUserInfo () {
        const send_data = {
          UserId: this.items.UserOrGroupId
        }
        var self = this
        this.axios.post('/GetUserInfo', send_data, {})
          .then(response => {
            if (response.data.error == 0) {
              // console.log("user info" , response.data.userInfo)
              self.user_info = response.data.userInfo
              var info = response.data.userInfo || {}
              var online = self.parseOnlineFlag(info)
              if (online === null && info.LastSeenDate) {
                var last = String(info.LastSeenDate)
                online = last.indexOf('آنلاین') !== -1 || last.toLowerCase().indexOf('online') !== -1
              }
              self.peerOnline = !!online
            }
          }).catch(e => {

        })
      },
      getGroupInfo () {
        // console.log("get group info")
        const send_data = {
          UserId: this.UserId,
          GroupId: this.items.UserOrGroupId
        }
        var self = this
        this.axios.post('/GetGroupInfo', send_data, {})
          .then(response => {
            if (response.data.error == 0) {
              // console.log("user info" , response.data.userInfo)
              self.user_info = response.data.userInfo
            }
          }).catch(e => {

        })
      },
      scrollToEnd () {
        var container = this.$el.querySelector('#chat_detail')
        var pageHeight = container.scrollHeight
        container.scrollTop = pageHeight
        // console.log("end" + container.scrollHeight)
      },
      convert_string_to_date (date) {
        var dateString = date

        var reggie = /(\d{2})\/(\d{2})\/(\d{4}) (\d{2}):(\d{2})/
        var dateArray = reggie.exec(dateString)

        // var date = dateArray[3]+"-"+dateArray[2]+"-"+dateArray[1]+"T00:00:00.000+03:30"
        try {
          var dateObject = new Date(
            (+dateArray[3]),
            (+dateArray[2]), // Careful, month starts at 0!
            (+dateArray[1]),
            (+dateArray[4]),
            (+dateArray[5]),
            (+dateArray[5])
          )
          return dateObject.toDateString()
        } catch (e) {
          return ''
        }
      },
      get_conversation_date (item) {
        var date = item.SubmitDateTimeMiladi || ''
        if (!date || !item.SubmitDateTime) {
          return ''
        }
        date = date.replace('  ', ' ')
        var days = 0
        var dateNow = new Date(this.convert_string_to_date(this.date_now))
        var conv_date = new Date(this.convert_string_to_date(date))
        // var conv_date_hour2 = new Date(item.SubmitDateTime)

        var reportDate = item.SubmitDateTime.substring(11)
        // console.log(item)
        days = dateNow - conv_date

        days = days / (1000 * 60 * 60 * 24)

        var ret
        if (days < 1) {
          ret = reportDate
        } else if (days >= 1 && days < 2) {
          ret = ' دیروز ' + reportDate
        } else if ((days < 8) && (days > 1)) {
          ret = days + ' روز قبل ' + reportDate
        } else {
          ret = item.SubmitDateTime
        }

        return ret
      },
    },
  }
</script>
<style lang="scss" scoped>
  .chat-header {
    background: #ffffff !important;
    background-color: #ffffff !important;
    color: #111;
    border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  }

  .chat-header-bar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    padding: 8px 12px;
    min-height: 56px;
  }

  .chat-header-user {
    display: flex;
    align-items: center;
    gap: 10px;
    flex: 1;
    min-width: 0;
    cursor: pointer;
  }

  .chat-header-avatar-wrap {
    position: relative;
    flex-shrink: 0;
  }

  .chat-header-avatar {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    object-fit: cover;
    flex-shrink: 0;
    background: #e5e7eb;
    display: block;
  }

  .chat-online-dot {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 11px;
    height: 11px;
    border-radius: 50%;
    background: #22c55e;
    border: 2px solid #fff;
    box-shadow: 0 0 0 0 rgba(34, 197, 94, 0.55);
    animation: online-pulse 1.6s ease-out infinite;
    z-index: 2;
  }

  @keyframes online-pulse {
    0% {
      box-shadow: 0 0 0 0 rgba(34, 197, 94, 0.55);
      transform: scale(1);
    }
    70% {
      box-shadow: 0 0 0 7px rgba(34, 197, 94, 0);
      transform: scale(1.05);
    }
    100% {
      box-shadow: 0 0 0 0 rgba(34, 197, 94, 0);
      transform: scale(1);
    }
  }

  .chat-header-user-text {
    min-width: 0;
    display: flex;
    flex-direction: column;
  }

  .chat-header-name {
    font-size: 13px;
    font-weight: 600;
    color: #111;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .chat-header-status {
    font-size: 12px;
    color: #6b7280;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .chat-header-status.is-online {
    color: #16a34a;
  }

  .chat-header-status.is-typing {
    color: #1c39bb;
    font-style: italic;
  }

  .chat-header-actions {
    display: flex;
    align-items: center;
    gap: 4px;
    flex: 1;
    min-width: 0;
  }

  .chat-header-action {
    width: 36px;
    height: 36px;
    border: none;
    background: transparent;
    border-radius: 50%;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    padding: 0;
  }

  .chat-header-action:hover {
    background: rgba(0, 0, 0, 0.06);
  }

  .chat-back-btn {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.6);
    backdrop-filter: blur(8px);
    border: 1px solid rgba(0, 0, 0, 0.08);
    display: inline-flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    padding: 0;
    color: #111;
    flex-shrink: 0;
  }

  .chat-back-btn:hover {
    background: rgba(0, 0, 0, 0.06);
  }

  .basemap {
    width: 100%;
    height: 500px;
  }

  .chat-modal-overlay {
    position: fixed;
    inset: 0;
    z-index: 100;
    background: rgba(0, 0, 0, 0.92);
    display: flex;
    flex-direction: column;
  }

  .chat-modal-panel {
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 0;
    background: #fff;
  }

  .chat-modal-toolbar {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 8px 12px;
    background: #1c39bb;
    color: #fff;
    flex-shrink: 0;
  }

  .chat-modal-title {
    flex: 1;
    font-size: 1rem;
    font-weight: 500;
  }

  .chat-modal-icon-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 6px;
    border: none;
    background: transparent;
    cursor: pointer;
    border-radius: 50%;
  }

  .chat-modal-icon-btn:hover {
    background: rgba(255, 255, 255, 0.15);
  }

  .chat-modal-text-btn {
    border: none;
    background: transparent;
    color: #fff;
    font-size: 0.95rem;
    cursor: pointer;
    padding: 6px 10px;
  }

  .chat-modal-body {
    flex: 1;
    overflow: auto;
    padding: 16px;
  }

  .chat-context-backdrop {
    position: fixed;
    inset: 0;
    z-index: 150;
    background: transparent;
  }

  .chat-context-menu {
    position: fixed;
    z-index: 151;
    min-width: 140px;
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.18);
    border: 1px solid #e5e7eb;
    overflow: hidden;
  }

  .chat-context-item {
    display: block;
    width: 100%;
    text-align: right;
    padding: 10px 16px;
    border: none;
    background: #fff;
    cursor: pointer;
    font-size: 14px;
    color: #111827;
  }

  .chat-context-item:hover {
    background: #f3f4f6;
  }

  .chat-audio-player {
    max-width: 240px;
    width: 100%;
    height: 36px;
  }

  .tag-close {
    cursor: pointer;
    display: inline-flex;
    align-items: center;
  }

  .chat-page {
    position: relative;
    width: 100%;
    height: 100vh;
    max-height: 100vh;
    overflow: hidden;
    padding-bottom: 0 !important;
    margin-bottom: 0 !important;
  }

  .chat-detail {
    position: relative;
    width: 100%;
    height: 100%;
  }

  .chat-body {
    height: 100vh;
  }

  .chat-detail .chat-text {
    padding-top: 72px !important;
    padding-bottom: 96px !important;
    height: 100vh !important;
    box-sizing: border-box;
  }

  .wa-footer {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 40;
    background: #f0f2f5;
    border-top: 1px solid #e9edef;
    padding: 8px 8px calc(8px + env(safe-area-inset-bottom));
    box-sizing: border-box;
  }

  .wa-row {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 8px;
    width: 100%;
  }

  .wa-bubble {
    flex: 1 1 auto;
    min-width: 0;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;
    background: #ffffff;
    border-radius: 24px;
    min-height: 48px;
    padding: 4px 8px;
    box-shadow: 0 1px 0.5px rgba(11, 20, 26, 0.13);
  }

  .wa-text {
    flex: 1 1 auto;
    min-width: 0;
    width: 0;
    border: 0;
    outline: 0;
    background: transparent;
    font-size: 15px;
    line-height: 20px;
    padding: 10px 4px;
    color: #111b21;
    margin: 0;
  }

  .wa-text::placeholder {
    color: #8696a0;
  }

  .wa-icon-btn {
    flex: 0 0 36px;
    width: 36px;
    height: 36px;
    border: 0;
    background: transparent;
    border-radius: 50%;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    margin: 0;
    cursor: pointer;
    position: relative;
    color: #54656f;
  }

  .wa-icon-btn img {
    width: 22px;
    height: 22px;
    display: block;
    pointer-events: none;
  }

  .wa-hidden-file {
    display: none !important;
  }

  .wa-fab {
    flex: 0 0 48px;
    width: 48px;
    height: 48px;
    border: 0;
    border-radius: 50%;
    background: #1c39bb;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    margin: 0;
    cursor: pointer;
    box-shadow: 0 1px 3px rgba(11, 20, 26, 0.4);
  }

  .wa-fab.record_button_active,
  #microphone_record_btn.record_button_active {
    background: #e53935 !important;
    transform: scale(1.05);
  }

  .wa-fab ::v-deep svg {
    width: 22px;
    height: 22px;
    display: block;
  }

  .wa-recording {
    display: flex;
    align-items: center;
    gap: 8px;
    color: #e53935;
    font-size: 14px;
    font-weight: 600;
    padding: 0 8px 8px;
  }

  .wa-recording-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #e53935;
    animation: wa-pulse 1s ease-in-out infinite;
  }

  @keyframes wa-pulse {
    0%, 100% { opacity: 1; }
    50% { opacity: 0.35; }
  }

  .wa-reply {
    display: flex;
    align-items: stretch;
    gap: 8px;
    margin: 0 0 8px;
    padding: 8px 10px;
    background: #ffffff;
    border-radius: 12px;
  }

  .wa-reply-bar {
    width: 4px;
    border-radius: 4px;
    background: #1c39bb;
    flex-shrink: 0;
  }

  .wa-reply-body {
    flex: 1;
    min-width: 0;
  }

  .wa-reply-label {
    display: block;
    font-size: 12px;
    color: #1c39bb;
    font-weight: 600;
  }

  .wa-reply-text {
    display: block;
    font-size: 13px;
    color: #667781;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .wa-reply-close {
    border: 0;
    background: transparent;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    padding: 4px;
  }

  .wa-attach-sheet {
    margin: 0 0 8px;
  }

  .wa-attach-grid {
    display: flex;
    gap: 12px;
    background: #ffffff;
    border-radius: 16px;
    padding: 14px 12px;
  }

  .wa-attach-item {
    flex: 1;
    border: 0;
    background: transparent;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 6px;
    cursor: pointer;
    position: relative;
    font-size: 12px;
    color: #54656f;
    padding: 0;
  }

  .wa-attach-icon {
    width: 48px;
    height: 48px;
    border-radius: 50%;
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }

  .wa-attach-icon--file {
    background: #7f66ff;
  }

  .wa-attach-icon--map {
    background: #ff7b6b;
  }

  .wa-attach-icon img,
  .wa-attach-icon svg {
    width: 24px;
    height: 24px;
    display: block;
  }

  .wa-attach-file {
    position: absolute;
    inset: 0;
    opacity: 0;
    cursor: pointer;
  }

  .chat-empty-state {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 50vh;
    padding: 24px 16px;
    color: #667781;
    font-size: 15px;
    text-align: center;
  }

  .wa-emoji-picker-wrap {
    position: absolute;
    bottom: 70px;
    left: 8px;
    right: 8px;
    z-index: 50;
  }

  .wa-emoji-picker,
  .wa-footer emoji-picker {
    display: block;
    width: 100%;
    max-width: 100%;
    height: 360px;
    --border-radius: 16px;
    --category-emoji-size: 1.3rem;
    --emoji-size: 1.5rem;
    --num-columns: 8;
    --background: #ffffff;
    --border-color: #e9edef;
    --button-hover-background: #f0f2f5;
    --input-border-color: #e9edef;
    --input-font-color: #111b21;
    --input-placeholder-color: #8696a0;
  }

  .wa-footer .attach-tags {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    padding: 0 4px 8px;
  }
</style>